(function() {
  // drop you code here it will be immediately executed

  /* Scalapay style in shadow root */

  document.addEventListener('DOMContentLoaded', function () {
      const widget = document.querySelector('div#scalapay-product-page-widget #widget-text scalapay-widget');

      if (!widget) {
        return;
      }

      function modifyStyles() {
          const spContainer = widget.shadowRoot.querySelector('#sp-container');
          if (spContainer) {
              spContainer.style.display = 'flex';
              spContainer.style.alignItems = 'center';
          } else {
              setTimeout(modifyStyles, 100);
          }
      }

      if (widget.shadowRoot) {
          modifyStyles();
      } else {
          widget.addEventListener('load', modifyStyles);
      }
  });
})();
